import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { useLockBodyScroll } from '../common/common_utils/useLockBodyScroll';

const EASE = [0.22, 1, 0.36, 1];

// Mobile: a panel sliding up from the bottom of the screen (company type, country).
export function BottomSheet({ open, title, onClose, children, className = '' }) {
  const reduceMotion = useReducedMotion();
  useLockBodyScroll(open);
  useEffect(() => {
    if (!open) return undefined;
    const onKey = event => { if (event.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);
  return createPortal(<AnimatePresence>
    {open && <>
      <motion.div key="veil" className="kycEntitySheetVeil" onClick={onClose}
        initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: reduceMotion ? 0 : 0.2 }} />
      <motion.div key="sheet" className={`kycEntitySheet${className ? ` ${className}` : ''}`} role="dialog" aria-modal="true" aria-label={title}
        initial={reduceMotion ? { opacity: 0 } : { y: '100%' }} animate={reduceMotion ? { opacity: 1 } : { y: 0 }}
        exit={reduceMotion ? { opacity: 0 } : { y: '100%' }} transition={{ duration: reduceMotion ? 0 : 0.3, ease: EASE }}>
        <span className="kycEntitySheetGrab" aria-hidden="true" />
        <div className="kycEntitySheetHead">
          <span>{title}</span>
          <button type="button" aria-label="Close" onClick={onClose}><i className="bi bi-x-lg" aria-hidden="true" /></button>
        </div>
        <div className="kycEntitySheetBody">{children}</div>
      </motion.div>
    </>}
  </AnimatePresence>, document.body);
}

